// extracted by mini-css-extract-plugin
export default {"page":"Auth_page__VH0eP","card":"Auth_card__LShcr"};